import { string, StringSchema } from 'yup';
import { locale } from '../yup-locale';
import * as yup from 'yup';
yup.setLocale(locale);

export const passwordValidate: StringSchema = string()
    .nonNullable()
    .required()
    .max(64)
    .min(8)
    .strict();
